export const ERoutePath = {
  MAIN_PAGE: '/',
  NEW_MAIN_PAGE: '/new-main',
  COLLECTIONS: '/collections/:id',
  NEWCOLLECTIONS: '/new-collections/:id',
  // ARTICLES: '/article/:id',
  ARTICLES1: '/article/1',
  ARTICLES2: '/article/2',
  ARTICLES3: '/article/3',
  ARTICLES4: '/article/4',
  ARTICLES5: '/article/5',
  ARTICLES6: '/article/6',
  ARTICLES7: '/article/7',
  ARTICLES8: '/article/8',
  ARTICLES9: '/article/9',
  ARTICLES10: '/article/10',
  ARTICLES11: '/article/11',
  ARTICLES12: '/article/12',
  ARTICLES13: '/article/13',
  ARTICLES14: '/article/14',
  ARTICLES15: '/article/15',
  ARTICLES16: '/article/16',
  ARTICLES17: '/article/17',
  ARTICLES18: '/article/18',
  ARTICLES19: '/article/19',
  ARTICLES20: '/article/20',
  ARTICLES21: '/article/21',
  FLATS: '/flats/:id',
  // LAYOUTPAGE: '/layout/',
  PROJECT: '/project/:id',
  INVESTMENT: '/invest',
  COLLECTIONS_ARTICLE: '/collections/',
  ARTICLES: '/articles',
  INVESTMENT_ARTICLE: '/invest/article/:id',
}
